import { motion } from "framer-motion";
import styled from "styled-components";
import SVG from "react-inlinesvg";

const MainContainer = styled.div`
  .baseButtonProseGeneratingPauseButton {
    border-radius: 8px !important;
    padding: 6px 8px !important;
    cursor: pointer;
    margin-top: 0px !important;
  }

  .pauseButton {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;

    .labels {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      .label {
        font-size: 14.8px;
        font-weight: 500;
      }

      .sublabel {
        font-size: 10px;
        font-weight: 600;
        min-width: 120px !important;
        text-align: left;
        letter-spacing: 0.02rem;
      }
    }
    svg {
      height: 24px;
      width: 24px;
      rect {
        fill: var(--cta-text-color);
      }
    }
  }
`;

function ProseGeneratingPauseButton({ onPause, currentProseMode }) {
  return (
    <MainContainer>
      <motion.button
        key={currentProseMode || "Thinking..."}
        className="baseButtonProseGeneratingPauseButton pauseButton"
        onClick={onPause}
        initial={{
          background: `linear-gradient(90deg, var(--primary-cta) ${0}%, var(--primary-cta-light) ${0}%)`,
        }}
        animate={{
          background: `linear-gradient(90deg, var(--primary-cta) ${90}%, var(--primary-cta-light) ${10}%)`,
          transition: {
            duration: 30,
            ease: "linear",
          },
        }}
      >
        <SVG src="/assets/pause.svg" />
        <div className="labels">
          <span className="label">Pause</span>
          <span className="sublabel">{currentProseMode || "Thinking..."}</span>
        </div>
      </motion.button>
    </MainContainer>
  );
}

export default ProseGeneratingPauseButton;
